import React, { useRef, useState, useEffect } from "react";
import { setErrorDialog, uploadBlobFile } from "../store/api/CommonFunctions";
import { CloudUpload, MicFill, Record2, RecordBtn, Upload } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";

function VoiceRecorder({ parentID, parentType, autoStart, style, onUpload }) {
    const [isRecording, setIsRecording] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);

    const recorderRef = useRef(null);
    const canvasRef = useRef(null);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const dataArrayRef = useRef(null);
    const animationRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isRecording) drawVisualizer();
        else cancelAnimationFrame(animationRef.current);
    }, [isRecording]);

    const startRecording = async () => {
        setAudioBlob(null);
        setAudioUrl(null);

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mediaRecorder = new MediaRecorder(stream);
        const chunks = [];

        mediaRecorder.ondataavailable = e => chunks.push(e.data);
        mediaRecorder.onstop = () => {
            const blob = new Blob(chunks, { type: "audio/webm" });
            setAudioBlob(blob);
            setAudioUrl(URL.createObjectURL(blob));
        };

        recorderRef.current = mediaRecorder;
        mediaRecorder.start();

        // تنظیم و پیوند صفحه صدا
        audioContextRef.current = new AudioContext();
        const source = audioContextRef.current.createMediaStreamSource(stream);
        analyserRef.current = audioContextRef.current.createAnalyser();
        analyserRef.current.fftSize = 256;
        dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);
        source.connect(analyserRef.current);

        setIsRecording(true);
    };

    const stopRecording = () => {
        if (recorderRef.current) {
            recorderRef.current.stop();
            recorderRef.current.stream.getTracks().forEach(t => t.stop());
            setIsRecording(false);
        }
    };

    const drawVisualizer = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const WIDTH = canvas.width;
        const HEIGHT = canvas.height;

        const draw = () => {
            animationRef.current = requestAnimationFrame(draw);
            analyserRef.current.getByteFrequencyData(dataArrayRef.current);

            ctx.clearRect(0, 0, WIDTH, HEIGHT);

            let barWidth = 3;
            let gap = 2;
            let x = WIDTH; // شروع از راست

            for (let i = 0; i < dataArrayRef.current.length; i++) {
                const barHeight = dataArrayRef.current[i] / 4; // ارتفاع کم

                ctx.fillStyle = "rgba(0, 180, 255, 0.9)";
                x -= barWidth + gap;

                ctx.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);
            }
        };

        draw();
    };

    // متد آپلود که بر اساس نکات شما است:
    const uploadAudio = async () => {
        if (!audioBlob) return;
        // در صورت نیاز می‌تونید کدهای مربوط به upload رو فعال کنید
        // const formData = new FormData();
        // formData.append("file", audioBlob, "voice.webm");
        // await fetch(...);

        // استفاده از تابع شما:
        const result = await uploadBlobFile(audioBlob, "voice.webm", parentID, parentType, "", false);
        if (result) {
            setErrorDialog(dispatch, "success", "بارگذاری صدا");
            if (typeof onUpload === "function")
                onUpload(result);
            setAudioUrl(null);
            setIsRecording(false);
        }
        else {
            setErrorDialog(dispatch, "Error", "بارگذاری صدا");
        }
    };
    useEffect(() => {
        if (autoStart) {
            startRecording()
        }
    }, [autoStart])

    return (
        <div
            style={{
                textAlign: "center",
                direction: "rtl",
                width: "320px",
                ...style
            }}
        >
            {isRecording &&
                <canvas
                    ref={canvasRef}
                    width={320}
                    height={40}
                    style={{
                        background: "transparent",
                        marginBottom: "10px"
                    }}
                />}
            {audioUrl && (
                <>
                    <audio controls src={audioUrl} style={{ width: "100%", height: "35px" }} />

                    <button
                        onClick={uploadAudio}
                        className="hoverIcon"
                        style={{
                            marginTop: "5px",
                            backgroundColor: "#4caf50",
                            padding: "8px 20px",
                            borderRadius: "10px",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            display: "inline-block"
                        }}
                    >
                        <CloudUpload size={18} /> بارگذاری
                    </button>
                </>
            )}
            {!isRecording && (
                <button
                    onClick={startRecording}
                    className="hoverIcon"
                    style={{
                        backgroundColor: "#00aaee",
                        padding: "8px 20px",
                        borderRadius: "10px",
                        color: "white",
                        border: "none",
                        margin: "5px",
                        cursor: "pointer",
                        display: "inline-block"
                    }}
                >
                    <MicFill size={18} /> شروع ضبط
                </button>
            )}
            {isRecording && (
                <button
                    onClick={stopRecording}
                    className="hoverIcon"
                    style={{
                        backgroundColor: "#ff4444",
                        padding: "8px 20px",
                        borderRadius: "10px",
                        color: "white",
                        border: "none",
                        cursor: "pointer"
                    }}
                >
                    ⏹ توقف
                </button>
            )}
        </div>
    );
}

export default VoiceRecorder;
